import { trackAbTestV2Variant } from 'dibs-buyer-layout/exports/clientABTestV2';
import {
    BEST_SELLERS_COLLECTION,
    PERSONALIZED_RERANK_TEST_NAME,
    SPONSORED_LISTINGS_TEST_NAME,
} from '../../utils/abTestHelper';
import { pageTypeConstants } from '../../constants/pageTypeConstants';
import { SortMap } from '../../constants/sbConstants';
import {
    MIN_ITEMS_COUNT,
    MOBILE_ITEMS_PER_ROW,
    RESP_ITEMS_PER_ROW,
} from '../helpers/getMergedSbAndSponsoredItems';
import { isUserInEurope } from 'dibs-regional-info/src/regionalInfoHelpers';
import { ITEM_REGION_ON_TIlE } from '../../shared/hooks/useShowItemLocationBadge';
import { trackEligibleForRerankEvent } from '../../utils/tracking/searchBrowse/addPersonalizationTrackingData';

type PersonalizedRerankProps = {
    pageType?: string | null;
    sortValue?: string | null;
    isEligibleForRerank?: boolean | null;
};
export const personalizedRerankTracking = ({
    pageType,
    sortValue,
    isEligibleForRerank,
}: PersonalizedRerankProps): void => {
    // This if should be the same as
    // https://github.com/1stdibs/dibs-graphql/blob/release/src/schema/inventory/itemSearch/solrQueries/generateResultQuery.ts#L228
    if (
        sortValue === SortMap.relevance ||
        sortValue === SortMap.buyPageRelevance ||
        (pageType !== pageTypeConstants.BUY && sortValue === SortMap.recommended)
    ) {
        trackAbTestV2Variant(PERSONALIZED_RERANK_TEST_NAME);
    }

    if (isEligibleForRerank) {
        trackEligibleForRerankEvent();
    }
};

type SponsoredListingsTrackingArgs = {
    itemCount: number;
    sponsoredCount: number;
    isMobile: boolean;
    isSearchPage: boolean;
};

export const sponsoredListingsTracking = ({
    itemCount,
    sponsoredCount,
    isMobile,
    isSearchPage,
}: SponsoredListingsTrackingArgs): void => {
    const hasEnoughItems = itemCount >= MIN_ITEMS_COUNT;
    const hasEnoughSponsoredItems = isMobile
        ? sponsoredCount >= MOBILE_ITEMS_PER_ROW
        : sponsoredCount >= RESP_ITEMS_PER_ROW;
    if (!isSearchPage || (hasEnoughItems && hasEnoughSponsoredItems)) {
        trackAbTestV2Variant(SPONSORED_LISTINGS_TEST_NAME);
    }
};

export const bestSellersSellabilityTracking = ({
    displayUriRef,
    pageType,
}: {
    displayUriRef: string;
    pageType: string;
}): void => {
    if (pageType === pageTypeConstants.COLLECTION && displayUriRef.includes('/best-sellers/')) {
        trackAbTestV2Variant(BEST_SELLERS_COLLECTION);
    }
};

export const itemRegionOnTileTracking = (): void => {
    const isInEurope = isUserInEurope();
    if (isInEurope) {
        trackAbTestV2Variant(ITEM_REGION_ON_TIlE);
    }
};
